// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"16":"highcharts","303":"widget","970":"lottie"}[chunkId] || chunkId) + ".js";
};